import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

export function NavLink({ shortUrl, displayText, activeSection }) {
  const isActive = activeSection && activeSection === shortUrl;

  return (
    <Nav.Link
      as={Link}
      to={"/#" + shortUrl}
      replace
      className={`header-link ${isActive ? "active" : ""}`}
    >
      {displayText}
    </Nav.Link>
  );
}
